import React, { useEffect } from 'react';
import LoginBox from '../../../components/LoginBox';
import Form from './components/Form';

const ResetPassword = () => {
  useEffect(() => {
    document.title = 'Reset Password';
  }, []);
  return (
    <LoginBox>
      <Form />
    </LoginBox>
  );
};

export default ResetPassword;
